/* ═══════════════════════════════════════════════════════════════════════
   CRÉAPANEL — assets/cp-texture.js (chargé par snippets/cp-decor-data.liquid)
   DÉCOR À L'ÉCHELLE RÉELLE + RELEVÉ DES PIÈCES
   Remplace le rendu « image étirée sur la pièce » (preserveAspectRatio slice :
   l'échelle changeait avec la taille de la pièce) par un motif en millimètres :
   taille du motif = window.CP_DECORS[décor].tex (métachamp de variante
     custom.texture_mm : l × h en mm, règle produit custom.texture_echelle_regle
     « 1 px = 1 mm », statut « à confirmer ») ;
   : une seule image par pièce, étirée dans le sens du fil (× 2,5 au plus, sinon un raccord en miroir au
     milieu) ; marbre, pierre, unis : une image agrandie et recadrée (voir fit, plus bas) ;
   le fil suit la plus longue arête de chaque pièce ; le sens du fil de
     l'image vient de tex.fil ('x' | 'y' | 'iso', statut « estimé »).
   Décor sans donnée tex (unis, ancien produit) : rendu du moteur inchangé.
   Relevé : chaque appel à addTextureBlock = une pièce ; la liste de la
   dernière vue est dans App._cpPieces (x, y, w, h en mm du dessin).
   ═══════════════════════════════════════════════════════════════════════*/
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg', XL = 'http://www.w3.org/1999/xlink';
  function getApp() { try { return (typeof App !== 'undefined') ? App : window.App; } catch (e) { return window.App; } }
  /* décor courant + données texture (tex : l, h en mm, fil) et aplat (hex) */
  function decor() {
    var base = (typeof window.CP_currentDecor === 'function') ? window.CP_currentDecor() : null;
    if (!base) base = texDecor();                           /* décor sans épaisseurs (crédence, placage) : trouvé dans CP_TEX */
    if (!base) return null;
    var raw = (window.CP_DECORS && window.CP_DECORS[base.name]) || {}, tx = (window.CP_TEX && window.CP_TEX[base.name]) || {};
    /* CP_TEX (cp-decor-data) : décors sans épaisseurs (crédence, placage…) et fichier de texture propre (texture_fichier) */
    var t = tx.img ? tx.tex : (raw.tex || tx.tex);          /* avec un fichier propre, son texture_mm le décrit */
    base.tex = (t && t.l > 0 && t.h > 0) ? t : null;
    base.hex = raw.hex || tx.hex || null;
    base.img = tx.img || null;
    base.vid = raw.vid || null;
    /*  dessin neutre, sans échelle ni badge ; l'aplat (cp-trace, cp-3d) est le gris neutre, pas celui du décor de
       repli (Anthracite a son aplat #94938E depuis le lot T2 : le dessin restait « Anthracite »)*/
    if (toChoose) { base.tex = null; base.img = null; base.hex = NEUTRAL_HEX; }
    return base;
  }
  window.CP_decorFull = decor;
  /* même correspondance nom → clé de variante du moteur que cp-gamme (normalizeId) */
  function texDecor() {
    var A = getApp(), map = window.CP_TEX; if (!map || !A || !A.S || !A.S.variant) return null;
    for (var name in map) {
      if (!Object.prototype.hasOwnProperty.call(map, name)) continue;
      var id = (typeof A.normalizeId === 'function') ? A.normalizeId(name)
        : String(name || '').toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
      if (id === A.S.variant) return { name: name, thk: null, c45: false, ref: '' };   /* thk null : pas de gamme (plan : « gamme » null, comme avant) */
    }
    return null;
  }
  function el(n, a) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); return e; }

  /* Angle (degrés) à donner au motif pour que le fil de l'image suive la direction thetaDeg */
  function grainAngle(fil, thetaDeg) {
    if (fil === 'y') return thetaDeg - 90;
    if (fil === 'x') return thetaDeg;
    return 0;                                   /* isotrope : pas de fil, pas de rotation */
  }

  /* ── + + : UNE image par pièce, comme une pièce taillée d'un seul tenant dans un panneau. Même calcul en
     2D (motif SVG, ici) et en 3D (coordonnées de texture, cp-3d) : window.CP_texture.fit.
     Décor à fil (texture_mm.fil 'x' ou 'y'), règle de : jamais de miroir ni de répétition. L'image est d'abord agrandie
       uniformément (k) juste ce qu'il faut pour couvrir la largeur de la pièce, puis ÉTIRÉE dans le sens du fil
       (s ≤ 3) pour couvrir la longueur ; si × 3 ne suffit pas, k monte. k × s > 6 : toujours une seule image
       (signalé par data-cp-depasse sur le motif). Recadrée au centre.
     Marbre, pierre, uni (fil 'iso') : une seule image agrandie uniformément pour couvrir la pièce, recadrée au
       centre, tournée d'un quart de tour si cela l'agrandit moins ; ni miroir ni répétition.
     Boîte de la pièce : ses sommets ramenés dans le repère du motif (origine ox, oy ; tourné de rot degrés).*/
  var STRETCH_MAX = 3, SCALE_MAX = 2;
  function fit(tex, Px, Py, noRot) {
    var L = Number(tex.l), H = Number(tex.h), f = tex.fil;
    if (f === 'x' || f === 'y') {
      var gx = f === 'x', Pg = gx ? Px : Py, Pc = gx ? Py : Px, Tg = gx ? L : H, Tc = gx ? H : L;
      var k = Math.max(1, Pc / Tc), s = Math.max(1, Pg / (Tg * k));      /* largeur couverte, puis étirement */
      if (s > STRETCH_MAX) { s = STRETCH_MAX; k = Math.max(k, Pg / (Tg * STRETCH_MAX)); }   /* × 3 ne suffit pas : k monte */
      var ig = Tg * k * s, ic = Tc * k, og = (Pg - ig) / 2, oc = (Pc - ic) / 2;
      var o = { mode: 'fil', n: 1, k: s, s: k, depasse: k * s > STRETCH_MAX * SCALE_MAX || k > SCALE_MAX, cx: Px / 2, cy: Py / 2 };
      if (gx) { o.axis = 'x'; o.x = og; o.y = oc; o.w = ig; o.h = ic; } else { o.axis = 'y'; o.x = oc; o.y = og; o.w = ic; o.h = ig; }
      return o;
    }
    var s0 = Math.max(Px / L, Py / H), s9 = Math.max(Px / H, Py / L), r = !noRot && s9 < s0 * 0.999, s = r ? s9 : s0;
    return { mode: 'iso', n: 1, rot90: r, k: 1, s: s, w: L * s, h: H * s, x: (Px - L * s) / 2, y: (Py - H * s) / 2, cx: Px / 2, cy: Py / 2 };
  }
  /* boîte des sommets pts (repère du dessin) dans le repère du motif, avec 1 mm de débord de chaque côté : le bord
     de la tuile du motif ne tombe jamais sur le bord de la pièce ; même boîte
     en 2D et en 3D*/
  var PAD = 1;
  function boxIn(pts, ox, oy, rot) {
    var a = rot * Math.PI / 180, c = Math.cos(a), s = Math.sin(a), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    pts.forEach(function (q) {
      var dx = q[0] - ox, dy = q[1] - oy, u = dx * c + dy * s, v = -dx * s + dy * c;
      if (u < x0) x0 = u; if (u > x1) x1 = u; if (v < y0) y0 = v; if (v > y1) y1 = v;
    });
    return { x0: x0 - PAD, y0: y0 - PAD, w: x1 - x0 + 2 * PAD, h: y1 - y0 + 2 * PAD };
  }
  /* ── Rendu des décors ──
     décor à fil (bois : texture_mm.fil 'x' ou 'y') : rendu « c », répétition à l'échelle (tuiles de texture_mm),
       rangées décalées au hasard (tirage fixe par taille de pièce), fondu doux de 120 mm aux raccords, sans miroir ;
     minéral (fil 'iso' : marbres, pierres ; en c, veines doublées aux raccords) : rendu « a », une image par pièce,
       agrandie (fit) ;
     uni : aplat (cp-trace, cp-3d), inchangé.
     Image de pièce fabriquée dans la page, dans le repère du fil, à la résolution de la source (2 048 px au plus en 2D,
     4 096 en 3D), posée comme une image unique : même boîte en 2D et en 3D ; échelle, fil et badge inchangés.*/
  var ISO_MODE = 'a';                                                /* minéraux : 'a' ; passer à 'c' tient en cette ligne */
  function texMode(tex) { return tex && (tex.fil === 'x' || tex.fil === 'y') ? 'c' : ISO_MODE; }
  var BLEND_MM = 120, SYN_MAX = 4096, SYN_MAX_2D = 2048, SYN_KEEP = 16, synCache = {}, synKeys = [], synImg = {}, synTimer = null;
  var tileCache = {}, synQueue = {}, synBusy = false, synQTimer = null, lastById = {}, cv3 = {}, cv3Keys = [];
  var synStats = { n: 0, ms_total: 0, ms_max: 0, last: null };       /* mesure*/
  function seeded(seed) { var s = (seed >>> 0) || 1; return function () { s = (Math.imul(s, 1664525) + 1013904223) >>> 0; return s / 4294967296; }; }
  function hashStr(t) { var h = 2166136261; for (var i = 0; i < t.length; i++) { h ^= t.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  /* tuile aux bords gauche et haut fondus (alpha de 0 à 1 sur o px) */
  function feathered(img, tw, th, o) {
    var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(tw)); c.height = Math.max(1, Math.round(th));
    var g = c.getContext('2d'); g.drawImage(img, 0, 0, c.width, c.height);
    g.globalCompositeOperation = 'destination-in';
    var gx = g.createLinearGradient(0, 0, o, 0); gx.addColorStop(0, 'rgba(0,0,0,0)'); gx.addColorStop(1, 'rgba(0,0,0,1)');
    g.fillStyle = gx; g.fillRect(0, 0, c.width, c.height);
    var gy = g.createLinearGradient(0, 0, 0, o); gy.addColorStop(0, 'rgba(0,0,0,0)'); gy.addColorStop(1, 'rgba(0,0,0,1)');
    g.fillStyle = gy; g.fillRect(0, 0, c.width, c.height);
    return c;
  }
  /* image (canvas) de w × h mm couverte de tuiles de tex.l × tex.h mm tirées de img (rendu c), repère du fil ;
     max : plus grand côté en px (2 048 en 2D, 4 096 en 3D) */
  function synthCanvas(img, tex, w, h, key, max) {
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!(iw > 0) || !(ih > 0) || !(w > 0) || !(h > 0)) return null;
    var ppm = Math.min(iw / Number(tex.l), ih / Number(tex.h), (max || SYN_MAX) / Math.max(w, h));
    var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.ceil(w * ppm)); cv.height = Math.max(1, Math.ceil(h * ppm));
    var g = cv.getContext('2d'), tw = Number(tex.l) * ppm, th = Number(tex.h) * ppm, x, y;
    var o = Math.min(BLEND_MM * ppm, tw / 3, th / 3), sx = tw - o, sy = th - o, R = seeded(hashStr(key));
    /* tuile fondue gardée (même source, même échelle) : la refaire depuis une source de 2 000 px coûtait l'essentiel */
    var tk = (img.currentSrc || img.src || '') + '|' + Math.round(tw) + 'x' + Math.round(th) + '|' + Math.round(o), tile = tileCache[tk];
    if (!tile) { tile = feathered(img, tw, th, o); var tks = Object.keys(tileCache); if (tks.length > 6) delete tileCache[tks[0]]; tileCache[tk] = tile; }
    for (y = -o; y < cv.height; y += sy) {
      var off = -R() * sx;                                          /* décalage aléatoire de la rangée */
      for (x = off - o; x < cv.width; x += sx) g.drawImage(tile, x, y);
    }
    var ms = ((window.performance && performance.now) ? performance.now() : Date.now()) - t0;
    synStats.n++; synStats.ms_total += ms; synStats.ms_max = Math.max(synStats.ms_max, ms); synStats.last = { px: cv.width + '×' + cv.height, ms: Math.round(ms) };
    return cv;
  }
  /* adresse (blob:) de l'image fabriquée, ou null. Mesuré au téléphone (CPU ×4) : fabriquer et encoder pendant le rendu
     coûtait 4 à 7 s sur un U ou un G (une image par taille intermédiaire). Désormais le rendu ne fabrique rien : les
     tailles demandées sont mises en file, fabriquées 150 ms après le dernier rendu, encodées hors du fil principal
     (toBlob), puis le dessin est refait une fois. En attendant, la pièce garde sa dernière image c (makePattern). */
  function synthRun() {
    if (synBusy) return;
    var ks = Object.keys(synQueue); if (!ks.length) return;
    var k = ks[0], job = synQueue[k]; delete synQueue[k];
    var im = synImg[job.url]; if (!im || !im.complete || !im.naturalWidth) { synthRun(); return; }
    var cv = null; try { cv = synthCanvas(im, job.tex, job.w, job.h, job.key, SYN_MAX_2D); } catch (e) { console.warn('[cp-texture] rendu c', e); }
    if (!cv || !cv.toBlob) { synthRun(); return; }
    synBusy = true;
    cv.toBlob(function (b) {
      synBusy = false;
      if (b) {
        synCache[k] = URL.createObjectURL(b); synKeys.push(k);
        while (synKeys.length > SYN_KEEP) { var old = synKeys.shift(), u = synCache[old]; delete synCache[old]; if (u) setTimeout(function () { try { URL.revokeObjectURL(u); } catch (e) {} }, 4000); }
      }
      if (b) swapIn(k, job, synCache[k]);
      if (Object.keys(synQueue).length) synthRun();
    }, 'image/jpeg', 0.9);
  }
  /* image prête : posée dans les motifs qui l'attendent, sans nouveau rendu du moteur (un rendu refaisait aussi la 3D
     et le prix : 0,7 s de plus au téléphone) */
  var wanted = {};
  function swapIn(k, job, u) {
    (wanted[k] || []).forEach(function (id) {
      var p = document.getElementById(id); if (!p || p.getAttribute('data-cp-k') !== k) return;
      var im = p.querySelector('image'); if (!im) return;
      im.setAttribute('x', 0); im.setAttribute('y', 0); im.setAttribute('width', p.getAttribute('width')); im.setAttribute('height', p.getAttribute('height'));
      im.removeAttribute('transform'); im.setAttribute('href', u); im.setAttributeNS(XL, 'xlink:href', u);
      p.setAttribute('data-cp-fit', 'iso'); p.setAttribute('data-cp-etirement', '1.00'); p.setAttribute('data-cp-echelle', '1.00'); p.removeAttribute('data-cp-depasse');
      lastById[id] = { src: job.url, url: u, w: job.w, h: job.h };
    });
    delete wanted[k];
    try { var A = getApp(); if (A) captionNow(A, decor()); } catch (e) {}   /* badge « Décor à l'échelle » relu sur les motifs posés */
  }
  function synthUrl(url, tex, w, h) {
    var key = 'c|' + Math.round(w) + 'x' + Math.round(h), k = url + '|' + key;
    if (synCache[k]) return synCache[k];
    var im = synImg[url];
    if (!im) { im = synImg[url] = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { clearTimeout(synQTimer); synQTimer = setTimeout(synthRun, 150); }; im.src = url; }
    synQueue[k] = { url: url, tex: tex, w: w, h: h, key: key };
    clearTimeout(synQTimer); synQTimer = setTimeout(synthRun, 150);
    return null;
  }
  /* 3D : canevas fabriqué sur place (pas d'encodage), gardé par taille de pièce */
  function synthCanvas3d(img, tex, w, h) {
    var k = (img.currentSrc || img.src || '') + '|c|' + Math.round(w) + 'x' + Math.round(h);
    if (cv3[k]) return cv3[k];
    var narrow = (window.innerWidth || 1024) < 768;                  /* écran étroit : 2 048 px suffisent (coût d'envoi à la carte graphique) */
    var cv = synthCanvas(img, tex, w, h, 'c|' + Math.round(w) + 'x' + Math.round(h), narrow ? SYN_MAX_2D : SYN_MAX); if (!cv) return null;
    cv3[k] = cv; cv3Keys.push(k); while (cv3Keys.length > 8) delete cv3[cv3Keys.shift()];
    return cv;
  }

  /* Motif ancré en (ox, oy), tourné de rot degrés, qui couvre la pièce de sommets pts. Renvoie son id. */
  function makePattern(svg, id, url, tex, ox, oy, rot, pts) {
    var defs = svg.querySelector('defs') || svg.insertBefore(el('defs', {}), svg.firstChild);
    var old = defs.querySelector('#' + id); if (old) old.remove();
    var b = (pts && pts.length > 2) ? boxIn(pts, ox, oy, rot) : { x0: 0, y0: 0, w: Number(tex.l), h: Number(tex.h) };
    if (!(b.w > 0) || !(b.h > 0)) b = { x0: 0, y0: 0, w: Number(tex.l), h: Number(tex.h) };
    var wantK = null;
    if (texMode(tex) === 'c' && url && !/^data:/.test(url)) {       /* bois : rendu c*/
      var su = synthUrl(url, tex, b.w, b.h), last = lastById[id];
      if (su) { lastById[id] = { src: url, url: su, w: b.w, h: b.h }; url = su; tex = { l: b.w, h: b.h, fil: 'iso' }; }
      else {
        wantK = url + '|c|' + Math.round(b.w) + 'x' + Math.round(b.h);   /* posée par swapIn dès qu'elle est prête */
        (wanted[wantK] = wanted[wantK] || []).indexOf(id) < 0 && wanted[wantK].push(id);
        if (last && last.src === url) { url = last.url; tex = { l: last.w, h: last.h, fil: 'iso' }; }   /* en attendant : sa dernière image c */
      }
    }
    var F = fit(tex, b.w, b.h);
    var p = el('pattern', { id: id, patternUnits: 'userSpaceOnUse', x: b.x0, y: b.y0, width: b.w, height: b.h,
      patternTransform: 'translate(' + ox + ' ' + oy + ') rotate(' + rot + ')' });
    p.setAttribute('data-cp', '1');
    if (wantK) p.setAttribute('data-cp-k', wantK);
    p.setAttribute('data-cp-fit', F.mode + (F.rot90 ? '-tourne' : ''));
    p.setAttribute('data-cp-etirement', F.k.toFixed(2));
    p.setAttribute('data-cp-echelle', F.s.toFixed(2));
    if (F.depasse) p.setAttribute('data-cp-depasse', '1');
    var add = function (tf) {
      var im = el('image', { x: F.x, y: F.y, width: F.w, height: F.h, preserveAspectRatio: 'none' });
      if (tf) im.setAttribute('transform', tf);
      im.setAttribute('href', url); im.setAttributeNS(XL, 'xlink:href', url);
      p.appendChild(im);
    };
    add(F.rot90 ? 'rotate(90 ' + F.cx + ' ' + F.cy + ')' : '');
    defs.appendChild(p);
    return id;
  }
  window.CP_texture = { grainAngle: grainAngle, makePattern: makePattern, fit: fit, boxIn: boxIn, mode: texMode, synthCanvas: synthCanvas3d, stats: synStats };

  /*  « Décor à l'échelle » seulement si le dessin est à l'échelle réelle EN TRAVERS du fil : facteur
     uniforme k ≤ 1,05 sur chaque pièce dessinée (data-cp-echelle de son motif, calculé par fit ; pour un décor iso,
     c'est son agrandissement). L'étirement dans le fil (s ≤ 3) reste admis ; quand × 3 ne suffit pas, fit fait monter k
     et le badge tombe. Motifs pris parmi ceux que le dessin utilise (fill url(#…)), pas les restes d'un rendu précédent.*/
  var K_MAX = 1.05;
  function scaleMax(A) {
    var svg = A && A.svg, m = 0; if (!svg) return 0;
    Array.prototype.forEach.call(svg.querySelectorAll('[fill^="url(#"]'), function (e) {
      var id = (e.getAttribute('fill').match(/^url\(#([^)]+)\)/) || [])[1], p = id && svg.querySelector('pattern[id="' + id + '"][data-cp-echelle]');
      var v = p ? parseFloat(p.getAttribute('data-cp-echelle')) : 0; if (v > m) m = v;
    });
    return m;
  }
  function caption(A, d) {
    setTimeout(function () { try { captionNow(A, d); } catch (e) {} }, 0);   /* après les motifs posés par cp-trace (rendu enveloppé après nous) */
  }
  function captionNow(A, d) {
    var stage = document.getElementById('stage'); if (!stage) return;
    var c = document.getElementById('cp-tex-cap');
    if (!c) {
      c = document.createElement('div'); c.id = 'cp-tex-cap';
      c.style.cssText = 'position:absolute;left:10px;bottom:8px;font-size:11px;color:#6b7280;background:rgba(255,255,255,.85);padding:2px 8px;border-radius:999px;pointer-events:none;z-index:2';
      if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
      stage.appendChild(c);
    }
    /*  « 1 px ≈ 1 mm, échelle à confirmer » était une note interne. Le client lit « Décor à l'échelle » ;
       la taille du motif reste lisible pour les contrôles (data-motif), pas à l'écran.*/
    /*  échelle « à confirmer » (texture_mm.statut, scans de nuancier) : aucune mention d'échelle*/
    var km = (d && d.tex) ? scaleMax(A) : 0;
    c.textContent = (d && d.tex && !d.tex.statut && km > 0 && km <= K_MAX) ? 'Décor à l\'échelle' : '';
    if (d && d.tex) { c.setAttribute('data-motif', d.tex.l + ' × ' + d.tex.h + ' mm'); c.setAttribute('data-echelle-max', km.toFixed(2)); }
    else { c.removeAttribute('data-motif'); c.removeAttribute('data-echelle-max'); }
    c.style.display = c.textContent ? '' : 'none';
  }

  function wrap(A) {
    if (A.__cpTexWrapped) return;
    A.__cpTexWrapped = true;
    var origBlock = A.addTextureBlock, origRender = A.render;

    A.render = function () {
      this._cpPieces = [];
      this._cpPatN = 0;
      if (this.svg) Array.prototype.forEach.call(this.svg.querySelectorAll('pattern[data-cp]'), function (p) { p.remove(); });
      var r = origRender.apply(this, arguments);
      try { caption(this, decor()); } catch (e) {}
      return r;
    };

    A.addTextureBlock = function (x, y, w, h, opts) {
      opts = opts || {};
      (this._cpPieces = this._cpPieces || []).push({ x: x, y: y, w: w, h: h, rot: !!opts.rot });
      var d = decor(), url = this.getWorkImageUrl && this.getWorkImageUrl();
      if (!d || !d.tex || !url || !(d.tex.l > 0) || !(d.tex.h > 0)) return origBlock.apply(this, arguments);
      var clipId = (opts.clipId === undefined) ? 'clip-assembly' : opts.clipId;
      var g = el('g', {});
      if (clipId) g.setAttribute('clip-path', 'url(#' + clipId + ')');
      var theta = (w >= h) ? 0 : 90;                          /* fil = plus longue arête */
      var id = 'cp-pat-' + (this._cpPatN = (this._cpPatN || 0) + 1);
      makePattern(this.svg, id, url, d.tex, x, y, grainAngle(d.tex.fil, theta), [[x, y], [x + w, y], [x + w, y + h], [x, y + h]]);
      g.appendChild(el('rect', { x: x, y: y, width: w, height: h, fill: 'url(#' + id + ')', style: 'pointer-events:none' }));
      if (opts.outline && opts.outline !== 'none') {
        g.appendChild(el('rect', { x: x, y: y, width: w, height: h, fill: 'none',
          style: 'pointer-events:none;stroke:' + opts.outline + ';stroke-width:' + (opts.outlineWidth || 6) + ';stroke-linejoin:round' }));
      }
      this.svg.appendChild(g);
    };

    try { A.render(); } catch (e) { console.warn('[cp-tex]', e); }
  }

  var tries = 0;
  var timer = setInterval(function () {
    var A = getApp();
    if (A && A.S && A.svg && typeof A.addTextureBlock === 'function' && A.__cpThkWrapped) {
      clearInterval(timer); wrap(A);
    } else if (++tries > 400) clearInterval(timer);
  }, 50);

  /*  le moteur prenait l'image de variante brute (featured_image.src, sans largeur) pour la
     texture du dessin, les vignettes de la fenêtre « Finition » et les aperçus de la barre et du récapitulatif :
     Placage_chene.jpg (3 685 px, 1 592 Ko) pour une vignette de 38 px. Le CDN de Shopify redimensionne
     (paramètre width) :
     texture : largeur de la source, jusqu'à 4 096 px (2 048 sur un écran étroit, pour la mémoire du téléphone) ; le CDN
     n'agrandit jamais une image, une source de 2 200 px reste à 2 200 (le motif est posé en mm, pas en pixels : l'échelle
     ne change pas) ; vignettes de la fenêtre : 360 px ; aperçus de la barre et du récapitulatif : 120 px.
     getWorkImageUrl est enveloppé au DOMContentLoaded, avant le démarrage du moteur (au load).*/
  var CARD_W = 360, THUMB_W = 120;
  function texW() { return (window.innerWidth || 1024) < 768 ? 2048 : 4096; }
  function cdnSized(u, w) {
    if (!u || typeof u !== 'string' || !/\/cdn\/shop\/|cdn\.shopify\.com\//.test(u)) return u;
    var base = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  window.CP_cdnSized = cdnSized;
  function sizeWork() {
    var A = getApp();
    if (!A || A.__cpImgSized || typeof A.getWorkImageUrl !== 'function') return !!(A && A.__cpImgSized);
    A.__cpImgSized = true;
    var o = A.getWorkImageUrl;
    A.getWorkImageUrl = function () {
      if (toChoose) return NEUTRAL;                             /*  aucun décor choisi, dessin neutre*/
      var d = decor(), u = (d && d.img) || o.apply(this, arguments);   /* texture_fichier (CP_TEX) avant l'image de la variante */
      /* É-2 : produit à plusieurs options (étagère, HPL, Dekton) : le moteur cherche l'image par la
         valeur du décor (« ch-ne-br-l ») parmi les titres complets (« ch-ne-br-l-17-26-cm ») et ne la trouve pas : dessin
         et 3D en aplat beige. Image de la variante choisie (celle du prix et du panier). Plan (1 option) : inchangé.*/
      if (!u && typeof this.getSelectedShopifyVariant === 'function') {
        var sv = this.getSelectedShopifyVariant(), fi = sv && (sv.featured_image || sv.image);
        u = (fi && (fi.src || (typeof fi === 'string' ? fi : null))) || null;
      }
      return u ? cdnSized(u, texW()) : u;
    };
    return true;
  }
  function sizeThumbs() {
    Array.prototype.forEach.call(document.querySelectorAll('#variants-container .variant-preview'), function (p) {
      var m = /url\(["']?([^"')]+)["']?\)/.exec(p.style.backgroundImage || ''); if (!m) return;
      var s = cdnSized(m[1], CARD_W); if (s !== m[1]) p.style.backgroundImage = 'url("' + s + '")';
    });
    Array.prototype.forEach.call(document.querySelectorAll('#bar-preview-variant img, #td-finition img'), function (im) {
      var src = im.getAttribute('src') || '', s = cdnSized(src, THUMB_W); if (s !== src) im.setAttribute('src', s);
    });
    hideUnavailable();
    filThumbs();
  }
  /*  la vignette d'un décor dont l'image a le fil
     vertical (texture_mm.fil = "y") est tournée d'un quart de tour, dans la fenêtre Finition, la barre et le
     récapitulatif. Le dessin et la 3D orientent déjà le fil dans la longueur des pièces : rien n'y change.*/
  function filOf(name) { var d = window.CP_DECORS && window.CP_DECORS[String(name || '').trim()]; return d && d.tex ? d.tex.fil : null; }
  function filCss() {
    if (document.getElementById('cp-fil-css')) return;
    var st = document.createElement('style'); st.id = 'cp-fil-css';
    st.textContent =
      /* vignette en fond (fenêtre Finition) : un calque tourné, aux dimensions inversées de la vignette */
      '#variants-container .variant-preview.cp-fil-y{position:relative;overflow:hidden;container-type:size}' +
      '#variants-container .variant-preview.cp-fil-y::before{content:"";position:absolute;left:50%;top:50%;width:100cqh;height:100cqw;' +
        'background:inherit;background-size:cover;background-position:center;transform:translate(-50%,-50%) rotate(90deg)}' +
      /* barre : vignette carrée ; récapitulatif : 56 × 32, boîte inversée puis marges pour garder la même place */
      '#bar-preview-variant img.cp-fil-y{transform:rotate(90deg)}' +
      '#td-finition img.finition-thumb.cp-fil-y{width:32px;height:56px;margin:-12px 12px;transform:rotate(90deg)}';
    document.head.appendChild(st);
  }
  function filThumbs() {
    filCss();
    Array.prototype.forEach.call(document.querySelectorAll('#variants-container .variant-opt'), function (o) {
      var p = o.querySelector('.variant-preview'), n = o.querySelector('.variant-name'); if (!p || !n) return;
      var y = filOf(n.textContent) === 'y'; if (p.classList.contains('cp-fil-y') !== y) p.classList.toggle('cp-fil-y', y);
    });
    var cur = (typeof window.CP_decorFull === 'function') ? window.CP_decorFull() : null, cy = !!(cur && cur.tex && cur.tex.fil === 'y');
    Array.prototype.forEach.call(document.querySelectorAll('#bar-preview-variant img, #td-finition img'), function (im) {
      if (im.classList.contains('cp-fil-y') !== cy) im.classList.toggle('cp-fil-y', cy);
    });
  }
  /*  un décor non commandable (variante indisponible : Marbre Pulpis clair, image de 92 × 200 px) sort
     de la fenêtre Finition et n'est jamais le décor choisi, ni par défaut ni par ?variant= : on passe alors au premier
     décor disponible de la liste (vrai clic, le moteur redessine). Donnée : CP_DECORS[nom].av (cp-decor-data).*/
  function unavailable(name) {
    var k = String(name || '').trim(), d = window.CP_DECORS && window.CP_DECORS[k];
    if (d) return d.av === false;
    return !!(window.CP_AVAIL && window.CP_AVAIL[k] === false);   /*  décors sans métachamp (crédence)*/
  }
  function hideUnavailable() {
    var opts = document.querySelectorAll('#variants-container .variant-opt'), first = null, cur = null;
    Array.prototype.forEach.call(opts, function (o) {
      var n = o.querySelector('.variant-name'), off = unavailable(n && n.textContent), disp = off ? 'none' : '';
      if (o.style.display !== disp) o.style.display = disp;
      if (!off && !first) first = o;
      if (o.classList.contains('active')) cur = o;
    });
    if (cur && cur.style.display === 'none' && first && !hideUnavailable.busy) {
      hideUnavailable.busy = true; first.click(); setTimeout(function () { hideUnavailable.busy = false; }, 200);
      /*  le client venu pour ce décor (ancienne carte, lien Google, ?variant=) passait sans un mot
         au premier décor de la liste (Anthracite). Il est prévenu, et le menu Finition s'ouvre pour qu'il choisisse.*/
      var gone = cur.querySelector('.variant-name');
      if (gone && !hideUnavailable.told) {
        hideUnavailable.told = true;
        var nm = gone.textContent.trim();
        setTimeout(function () {
          var bt = document.getElementById('bar-btn-variant'); if (bt) bt.click();
          goneNote(nm);
        }, 400);
      }
    }
  }
  /* suite : la phrase est DANS la fenêtre Finition, sous son titre (en bulle, elle cachait les 43 px
     du bas de la fenêtre à 375) ; tant que le client n'a pas choisi, aucun décor n'y est présenté comme choisi (le premier
     décor disponible reste l'état du configurateur, sans surbrillance). Retirée au premier choix ou à la fermeture.*/
  /*  (b), décision : fermer la fenêtre reste libre ; mais jusqu'au premier choix du client,
     « Finition : À choisir » dans la barre et le récapitulatif (sans vignette), aucun décor surligné, et « Ajouter au
     panier » rouvre la fenêtre Finition avec « Choisissez d'abord un décor. », sans ajout.*/
  var toChoose = false, chooseMo = null;
  /*  en « À choisir », le dessin montrait la texture du décor de repli (Anthracite),
     que le client pouvait croire choisi. Dessin NEUTRE (gris clair uni, image de 1 × 1 px) et « Choisissez un décor » au
     centre du dessin jusqu'au premier choix. Le prix reste : un seul prix pour tous les décors d'un produit.*/
  var NEUTRAL = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR4nGN4+vQRAAVfAq02I082AAAAAElFTkSuQmCC', NEUTRAL_HEX = '#E5E5E2';   /* même gris */
  function chooseCap(on) {
    var st = document.getElementById('stage'), c = document.getElementById('cp-choose-cap');
    if (!on) { if (c && c.parentNode) c.parentNode.removeChild(c); return; }
    if (!st || c) return;
    c = document.createElement('div'); c.id = 'cp-choose-cap'; c.setAttribute('aria-hidden', 'true');   /* le message lu est dans la fenêtre Finition et la barre */
    c.textContent = 'Choisissez un décor';
    c.style.cssText = 'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:3;pointer-events:none;padding:8px 16px;border-radius:999px;' +
      'background:rgba(255,255,255,.92);color:#0d3527;font-size:15px;font-weight:600;box-shadow:0 1px 4px rgba(0,0,0,.12);white-space:nowrap';
    if (getComputedStyle(st).position === 'static') st.style.position = 'relative';
    st.appendChild(c);
  }
  function redraw() { var A = getApp(); try { if (A && typeof A.render === 'function') A.render(); } catch (e) {} }
  function chooseMark() {
    if (!toChoose) return;
    var v = document.getElementById('bar-value-variant'), pv = document.getElementById('bar-preview-variant'), td = document.getElementById('td-finition');
    if (v && v.textContent !== 'À choisir') { v.setAttribute('data-cp-was', v.textContent); v.textContent = 'À choisir'; }
    if (pv && pv.style.visibility !== 'hidden') pv.style.visibility = 'hidden';
    if (td && !td.querySelector('.cp-choose')) { td.setAttribute('data-cp-was', td.innerHTML); td.innerHTML = '<span class="finition-name cp-choose">À choisir</span>'; }
  }
  function chooseStart() {
    var was = toChoose;
    toChoose = true; chooseMark(); chooseCap(true);
    if (!was) setTimeout(function () { redraw(); chooseMark(); }, 0);   /*  le dessin passe au neutre ; le rendu réécrit la barre*/
    var vc = document.getElementById('variants-container');
    if (vc && !vc.__cpChoosePick) {                            /* choix fait plus tard (fenêtre rouverte par la barre, clavier compris) */
      vc.__cpChoosePick = true;
      vc.addEventListener('click', function (e) { if (toChoose && e.target && e.target.closest && e.target.closest('.variant-opt')) chooseEnd(); }, true);
    }
    if (chooseMo || typeof MutationObserver !== 'function') return;
    chooseMo = new MutationObserver(function () { if (toChoose) chooseMark(); });   /* le moteur réécrit barre et récapitulatif */
    ['bar-value-variant', 'bar-preview-variant', 'td-finition'].forEach(function (id) {
      var e = document.getElementById(id); if (e) chooseMo.observe(e, { childList: true, characterData: true, subtree: true });
    });
  }
  function chooseEnd() {                                    /* premier choix : textes du moteur remis (le moteur passe ensuite au décor choisi) */
    if (!toChoose) return;
    toChoose = false; if (chooseMo) { chooseMo.disconnect(); chooseMo = null; }
    var v = document.getElementById('bar-value-variant'), pv = document.getElementById('bar-preview-variant'), td = document.getElementById('td-finition');
    if (v && v.textContent === 'À choisir' && v.hasAttribute('data-cp-was')) v.textContent = v.getAttribute('data-cp-was');
    if (pv) pv.style.visibility = '';
    if (td && td.querySelector('.cp-choose') && td.hasAttribute('data-cp-was')) td.innerHTML = td.getAttribute('data-cp-was');
    var vc = document.getElementById('variants-container'); if (vc) vc.classList.remove('cp-nochoice');
    chooseCap(false);
    setTimeout(redraw, 0);                                    /*  texture du décor choisi (même si c'est celui de repli)*/
  }
  window.addEventListener('click', function (e) {
    if (!toChoose || !e.target || !e.target.closest || !e.target.closest('#btn-add-cart')) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var pop = document.getElementById('popup-variant'), bt = document.getElementById('bar-btn-variant');
    if (bt && !(pop && pop.classList.contains('is-open'))) bt.click();
    setTimeout(function () { goneNote(null, 'Choisissez d\'abord un décor.'); }, 50);
  }, true);
  function goneNote(nm, msg) {
    var txt = msg || '« ' + nm + ' » n\'est plus proposé : choisissez un autre décor.';
    chooseStart();
    var pop = document.getElementById('popup-variant'), head = pop && pop.querySelector('.config-popup-header'), vc = document.getElementById('variants-container');
    if (!pop || !head || !vc) { try { if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(txt, 'info', 8000); } catch (e) {} return; }
    if (!document.getElementById('cp-gone-css')) {
      var st = document.createElement('style'); st.id = 'cp-gone-css';
      /* premier élément de la grille des décors, sur toute sa largeur : aligné sur les cartes*/
      st.textContent = '#cp-decor-gone{grid-column:1/-1;margin:0;padding:8px 12px;border-radius:8px;background:#f1ece2;color:#0d3527;font-size:14px;line-height:1.4}' +
        '#variants-container.cp-nochoice .variant-opt.active:not(:hover){border-color:var(--border);background:var(--bg-card)}' +
        '#variants-container.cp-nochoice .variant-opt.active:not(:hover) .variant-preview{border-color:var(--border)}' +
        '#variants-container.cp-nochoice .variant-opt.active:not(:hover) .variant-name{color:var(--text-secondary);font-weight:400}';
      document.head.appendChild(st);
    }
    var p = document.getElementById('cp-decor-gone') || document.createElement('p');
    p.id = 'cp-decor-gone'; p.setAttribute('role', 'status'); p.textContent = txt;
    if (p.parentNode !== vc) vc.insertBefore(p, vc.firstChild);
    vc.classList.add('cp-nochoice');
    if (vc.__cpGoneDone) vc.__cpGoneDone();                   /* phrase précédente (bulle d'ajout) : un seul jeu d'écouteurs */
    var mo = null, mv = null, over = false, pick = function (e) { if (e.target && e.target.closest && e.target.closest('.variant-opt')) { done(); chooseEnd(); } };
    function done() {                                         /* phrase retirée ; « À choisir » reste jusqu'au premier choix */
      over = true; vc.__cpGoneDone = null;
      if (p.parentNode) p.parentNode.removeChild(p);
      if (!toChoose) vc.classList.remove('cp-nochoice');
      vc.removeEventListener('click', pick, true); if (mo) mo.disconnect(); if (mv) mv.disconnect();
    }
    vc.__cpGoneDone = done;
    vc.addEventListener('click', pick, true);
    if (typeof MutationObserver === 'function') {
      mo = new MutationObserver(function () { if (!pop.classList.contains('is-open')) done(); });
      mo.observe(pop, { attributes: true, attributeFilter: ['class'] });
      /* grille refaite par le moteur : la phrase reprend sa place en tête */
      mv = new MutationObserver(function () { if (!over && p.parentNode !== vc) vc.insertBefore(p, vc.firstChild); });
      mv.observe(vc, { childList: true });
    }
  }
  function watchThumbs() {
    var q = false, later = function () { if (q) return; q = true; setTimeout(function () { q = false; sizeThumbs(); }, 0); };
    ['variants-container', 'bar-preview-variant', 'td-finition'].forEach(function (id) {
      var e = document.getElementById(id); if (e) new MutationObserver(later).observe(e, { childList: true, subtree: true });
    });
    sizeThumbs();
  }
  if (!sizeWork()) document.addEventListener('DOMContentLoaded', function () { sizeWork(); watchThumbs(); });
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchThumbs);
  else watchThumbs();
})();
